import { configureStore } from "@reduxjs/toolkit";
import whiskiesReducer from "../redux/slices/whiskiesSlice";
import userReducer from "../redux/slices/userSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const userPersistConfig = {
  key: "user",
  storage,
};

const whiskeyPersistConfig = {
  key: "whiskey",
  storage,
};

const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedWhiskeyReducer = persistReducer(
  whiskeyPersistConfig,
  whiskiesReducer,
);

const store = configureStore({
  reducer: {
    whiskies: persistedWhiskeyReducer,
    user: persistedUserReducer, // Persist the user slice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
